import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const BAD_DATA_QUERY_KEY = "bad-data-state";

export const useBadDataState = (productId: string): boolean => {
	const { data } = useQuery<boolean>({
		queryKey: [BAD_DATA_QUERY_KEY, productId],
		queryFn: () => false,
		enabled: false,
		staleTime: Number.POSITIVE_INFINITY,
	});
	return data ?? false;
};

export const useSetBadDataState = (productId: string) => {
	const queryClient = useQueryClient();
	return useCallback(
		(value: boolean) => {
			queryClient.setQueryData<boolean>([BAD_DATA_QUERY_KEY, productId], value);
		},
		[queryClient, productId],
	);
};
